import popup from "~/views/Popup/popup";
import { getVideo } from "~/redux/video/helpers";
import { get } from "lodash";
import Cookies from "js-cookie";

export const getItemId = (id = '', video = null) => {
    if(id) return id;
    if(video && video.id) return video.id;
    if(video && video.gist) return video.gist.id;
    return id;
}

export const getSeriesImage = (seriesData) => {
    let seriesImg = '';
    if(seriesData && seriesData.length > 0){
        const {_32x9} = seriesData[0].gist.imageGist;
        seriesImg = _32x9 ? _32x9 : "";
    }
    return seriesImg ? `${seriesImg}?impolicy=resize&w=546&h=154` : '';
}

export const videoPlayHandler = (e, video) => {
    e.preventDefault();
    const customControls = {
        volumePanel: { inline: false },
        children: [
            "playToggle",
            "progressControl",
            "currentTimeDisplay",
            "timeDivider",
            "durationDisplay",
            "volumePanel",
            "fullscreenToggle"
        ]
    };
    const watchedTime = video.watchHistory
        ? video.watchHistory.watchedTime
        : video.watchedTime;
    const customSkin = "./newsSkin";
    const videoCopy = {...video};
    const videoInfo = {
        ...videoCopy,
        fileType: 'episode',
        watchedTime: watchedTime,
    };
    popup.newsEpisodeOverlay({
        video: videoInfo,
        customSkin,
        customControls
    });
}

export const getTrailer = async (video) => {
    let { contentDetails } = video;
    let trailerId = null;
    let trailer = null;

    if( contentDetails ) {
        if( contentDetails.trailers && contentDetails.trailers.length > 0 ){
            trailerId = contentDetails.trailers[0].id;
        } else {
            return trailerId;
        }
    } else {
        await getVideo(video.id, res=>{
            video = res.data.video;
            contentDetails = video.contentDetails;
            if( contentDetails ) {
                if( contentDetails.trailers && contentDetails.trailers.length > 0 ){
                    trailerId = contentDetails.trailers[0].id;
                } else {
                    return trailerId;
                }
            }
        })
    }
    if(trailerId){
        await getVideo(trailerId, res=>{
            trailer = res.data.video;
        })
    }
    return trailer;
}

export const pauseTrailerPlayer = () => {
    if(window.newsTrailerPlayer && window.newsTrailerPlayer.player_){
        window.newsTrailerPlayer.pause();
    }
}

export const muteLivePlayer = () => {
    if(window.newsLivePlayer && window.newsLivePlayer.player_){
        window.newsLivePlayer.muted(true)
    };
}

export const pauseLivePlayer = () => {
    if(window.newsLivePlayer && window.newsLivePlayer.player_){
        window.newsLivePlayer.pause();
    };
}

export const getLocalizedVal = (path) => {
    const messages = window.settings.genericMessages;
    var chosenLangCode = Cookies.get('userLanguageSelection');
    if(chosenLangCode === "") {
      chosenLangCode = window.settings.languages.default.code
    }
    const localizedVal = get(messages, `localizationMap.${chosenLangCode}.${path}`)
    const defaultVal = get(messages, path)
    return localizedVal || defaultVal;
}

export const checkExtras = (seasons) => {
    if(seasons.length === 0) return;
    let hasExtras = false;
    for(let i = 0; i < seasons.length; i++) {
        if(seasons[i].title.toLowerCase() === 'extras'){
            hasExtras = true;
            break;
        }
    }
    return hasExtras;
}